export const zoeStrings = {
	composerPlaceholder: "Ask Zoe anything…",
	emptyStateHeadline: "Hi — what would you like to work on?",
	emptyStatePromptsFallback: [
		"Summarize what's slipping in my pipeline this quarter.",
		"Which deals are most likely to close this month?",
		"What tasks do I have due this week?",
		"List my overdue follow-ups."
	],
	thinking: {
		default: "Thinking…",
		drafting: "Drafting…",
		writing: "Writing…",
		looking: "Looking at this page…"
	},
	sourcesLabel: "Sources",
	verifyDisclaimer:
		"Zoe can make mistakes. Verify important info before sending.",
	errors: {
		interrupted: "Something interrupted that — want me to try again?",
		rateLimited: "Zoe needs a moment. Try again in a few seconds.",
		network: "Couldn't reach Zoe. Check your connection and try again.",
		serverContext:
			"Zoe couldn't read this page. Try asking a more specific question."
	},
	actions: {
		retry: "Try again",
		stop: "Stop",
		edit: "Edit",
		copy: "Copy",
		regenerate: "Try again",
		apply: "Apply"
	},
	contextLabel: "Context",
	contextAdd: "Add"
} as const;

export type ZoeStrings = typeof zoeStrings;
